import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router/composables.js'
import { debounce } from 'lodash'
import { Inspiration } from '@/types/discover'
import { authModule, discoverModule, eventModule } from '@/store'
import LDialog from '@/global-components/LDialog.vue'
import InspirationSearchCard from '@/components/discover/InspirationSearchCard.vue'
import { DiscoverSearchQueryType } from '@/utils/enums'
import { logEvent, thumbnailImage } from '@/utils/utility-manager'


export default /*#__PURE__*/_defineComponent({
  __name: 'DiscoverSearchModal',
  setup(__props) {

const showDialog = ref(false)

const searchValue = ref('')
const suggestions = ref()
const isSearching = ref(false)
const router = useRouter()

const inspirations = computed(() => {
  return discoverModule.inspirationsBySearch
})

const debouncedSearch = debounce(async () => {
  await discoverModule.fetchBySearchTerm({
    searchType: DiscoverSearchQueryType.KEYWORDS,
    value: searchValue.value,
    page: 0,
  })
  isSearching.value = false
}, 500)

function closeModal() {
  eventModule.setDiscoverSearchModal(false)
}

function handleInspirationClick(inspiration: Inspiration) {
  logEvent('inspiration_opened', {
    context: authModule.loggedIn ? 'signed_in' : 'onboarding_v3',
    inspiration_id: inspiration._id,
    source: 'discover_search',
  })

  router.push({
    name: 'discover-inspiration-inspiration',
    params: {
      inspiration: inspiration._id,
      name: inspiration.name,
    },
  })
  eventModule.setDiscoverSearchModal(false)
}

function handleCategoryClick(category: any) {
  router.push({
    name: 'discover-categories-categories',
    params: {
      categories: category._id,
      name: category.name,
    },
  })
  eventModule.setDiscoverSearchModal(false)
}

watch(
  () => eventModule.discoverSearchModal,
  (newValue) => {
    showDialog.value = newValue
  },
)

watch(searchValue, () => {
  isSearching.value = true
  debouncedSearch()
})

onMounted(async () => {
  await discoverModule.fetchSuggestions()
  suggestions.value = discoverModule.suggestions
})

function getThumbnail(image: string, size: number): string {
  return thumbnailImage(image, size)
}

return { __sfc: true,showDialog, searchValue, suggestions, isSearching, router, inspirations, debouncedSearch, closeModal, handleInspirationClick, handleCategoryClick, getThumbnail, LDialog, InspirationSearchCard }
}

})